export class RMDProviderFilterModel {
  pageNumber: number;
  pageSize: number;
  orderBy: string;
  keywordFilter: string;
  providerSearch: string;
  fromDate: string;
  todate: string;
  isFavorite: boolean;
  userId: number;
  unreadonly: boolean;
  carrierIds: string;
}